import React from 'react';
import styled from 'styled-components';

const RichText = styled.div`
  line-height: ${({ forceLineHeight }) => (forceLineHeight ? '1.375' : 'inherit')};

  ul:not([class*='-sc-']):not([class*='styled__']) {
    padding-left: 1rem;
    list-style: inherit;

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {  
      list-style: disc;
    }

    li:not([class*='-sc-']):not([class*='styled__']) {
      @media (min-width: 1px) {
        font-size: inherit;
        line-height: inherit;
        padding-left: 0;
      }

      @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {  
        padding: 1px 0;
      }

      &:before {
        content: '';
      }
    }
  }
`;

export default RichText;
